export function formatDuration(duration: number): string {
  return new Date(duration).toISOString().slice(14, -5);
}
